import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import * as moment from "moment";
import NotificationSystem from "react-notification-system";
import {connect} from "react-redux";
import {style} from "variables/Variables.jsx";
import {isApiResponse, date_range_config} from '../helpers/utils.js';
import MultiCsvReportDownload from '../components/DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../filters/ServiceMerchantFilter.jsx';
import StoreFilter from '../filters/ServiceStoreFilter.jsx';
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import CityFilter from '../filters/ServiceCityFilter.jsx';
import StateFilter from '../filters/StateFilter.jsx';
import ProductTypeFilter from '../filters/ServiceProductFilter.jsx';
import OpenTicketIssueSubCategory from '../filters/ServiceIssueSubCategory.jsx';
import ChannelNameFilter from '../filters/ChannelNameFilter.jsx';
import TeamMemberNameFilter from '../filters/TeamMemberNameFilter.jsx';
import TeamNameFilter from '../filters/TeamNameFilter.jsx';
import OpenTicketAgeingFilter from '../filters/OpenTicketAgeingFilter.jsx';
import AsoAssignmentFilter from '../filters/AsoAssignmentFilter.jsx';
import TatStatusFilter, { TAT_STATUS_DEFAULT } from '../filters/TatStatusFilter.jsx';
import { AGE_BUCKETS, ASO_ASSIGNMENT_BUCKETS } from './agingBuckets.js';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import MerchantTab from './MerchantTab.jsx';
import StoreTab from './StoreTab.jsx';
import IssueCategoryTab from './IssueCategoryTab.jsx';
import ChannelTab from './ChannelTab.jsx';
import ProductTab from './ProductTab.jsx';
import CityTab from './CityTab.jsx';
import StateTab from './StateTab.jsx';
import TeamTab from './TeamTab.jsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import LastRefresh from './LastRefresh.jsx';
const diff = moment().diff(moment().subtract(4, 'months'), 'days');
var date_config = date_range_config(diff, '0', '2020-02-01','0');

class OpenTicketsAgingReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit: date_config.end_date_limit,
            merchantID: '',
            chainID: '',
            storeID: '',
            merchantValue: null,
            chainValue: null,
            storeValue: [],
            ciutidIds: '',
            object_code: [],
            issue_type: "",
            cf_issue_sub_category: "",
            selected_tab: 'Merchant Name',
            isChange: false,
            ticket_id: '',
            cf_utid: '',
            beat_plan_date: null,
            model_visible: false,
            is_submit_disable: true,
            cf_merchant_contact_number: "",
            refreshKey: 0,
            cf_issue_sub_category: "",
            channel:"",
            city:"",
            state:"",
            team:"",
            product:"",
            ageing: AGE_BUCKETS.slice(),
            aso_assignment: ASO_ASSIGNMENT_BUCKETS.slice(),
            tat_status: TAT_STATUS_DEFAULT.slice(),
            shouldLoadData: false,
            isFilterVisible: false,
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1: level = "success"; break;
            case 2: level = "warning"; break;
            case 3: level = "error"; break;
            case 4: level = "info"; break;
            default: break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (<div>{msg}</div>),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        if(decoded.object_type === 'Merchant'){
            this.setState({merchantID: arrayCode})
        }
        if(decoded.object_type === 'Chain'){
            this.setState({chainID: arrayCode})
        }
        if(decoded.object_type === 'Store'){
            this.setState({storeID: arrayCode})
        }

        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email: decoded.email
        });
    }
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem,refreshKey: this.state.refreshKey + 1, shouldLoadData: true });

        const style = document.createElement('style');
        style.innerHTML = `
        .filter-panel {
            max-height: 0 !important;
            overflow: hidden !important;
            opacity: 0 !important;
            transition: all 0.4s ease-in-out !important;
            padding: 0 !important;
            margin: 0 !important;
            display: block !important;
            height: 0 !important;
            visibility: hidden !important;
        }

        .filter-panel.show {
            max-height: 800px !important;
            opacity: 1 !important;
            padding: 10px 0 !important;
            margin: -10px 10 !important;
            height: auto !important;
            visibility: visible !important;
            overflow: visible !important;
        }

        .filter-panel.hide {
            max-height: 0 !important;
            opacity: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            height: 0 !important;
            visibility: hidden !important;
            overflow: hidden !important;
        }

        /* Single grid so filters hidden per user type collapse without leaving gaps. */
        .filter-panel .filter-grid {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            margin: 0 -6px;
        }

        .filter-panel .filter-item {
            flex: 0 0 16.666%;
            max-width: 16.666%;
            padding: 0 6px;
            margin-bottom: 10px;
            min-width: 0;
            transition: all 0.4s ease-in-out !important;
        }

        .filter-panel .filter-item > label {
            display: block;
            margin-bottom: 4px;
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
            color: #4a4a4a;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        /* The shared rules absolutely position the calendar icon at a fixed
           top: 35px against whatever ancestor happens to be positioned, which
           predates this flex filter grid and leaves the icon off the input.
           Anchor it to the picker container and centre it on the field instead. */
        .filter-panel .filter-item .react-bootstrap-daterangepicker-container {
            position: relative;
            display: block;
        }

        .filter-panel .filter-item .react-bootstrap-daterangepicker-container i,
        .filter-panel .filter-item.date-icon-small .react-bootstrap-daterangepicker-container i {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 12px;
            line-height: 1;
            color: #565656;
            z-index: 1;
            pointer-events: none;
        }

        .filter-panel .filter-item .react-bootstrap-daterangepicker-container .form-control {
            padding-left: 28px;
        }

        .filter-panel .filter-actions {
            flex: 0 0 auto;
            margin-left: auto;
            padding: 0 6px;
            margin-bottom: 10px;
            white-space: nowrap;
        }

        /* The shared button rules float right with position offsets, which would
           reverse the pair and collapse this container in a flex layout. */
        .filter-panel .filter-actions .apply-filter,
        .filter-panel .filter-actions .reset-filter {
            float: none;
            position: static;
            right: auto;
            margin: 0;
            vertical-align: bottom;
            min-width: 80px;
        }

        .filter-panel .filter-actions .apply-filter + .reset-filter {
            margin-left: 8px;
        }

        @media (max-width: 1400px) {
            .filter-panel .filter-item { flex: 0 0 20%; max-width: 20%; }
        }

        @media (max-width: 1199px) {
            .filter-panel .filter-item { flex: 0 0 25%; max-width: 25%; }
        }

        @media (max-width: 991px) {
            .filter-panel .filter-item { flex: 0 0 33.333%; max-width: 33.333%; }
        }

        @media (max-width: 767px) {
            .filter-panel .filter-item { flex: 0 0 50%; max-width: 50%; }
            .filter-panel .filter-actions { flex: 0 0 100%; text-align: right; }
        }
    `;
        document.head.appendChild(style);
    }
    TicketDownloadCheck(type, e){
        var fn = ''; var url = '';
        var report_code = '';
        var group_by = ''
        if(type==='Merchant Name'){
            fn='open_tickets_aging_merchant_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_merchant_wise"
            group_by = 'merchant'
        }
        if(type==='Issue Category'){
            fn='open_tickets_aging_issue_category_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_issue_category_wise"
            group_by = 'issue_category'
        }
        if(type==='Channel'){
            fn='open_tickets_aging_channel_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_channel_wise"
            group_by = 'channel'
        }
        if(type==='Product'){
            fn='open_tickets_aging_product_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_product_wise"
            group_by = 'product'
        }
        if(type==='City'){
            fn='open_tickets_aging_city_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_city_wise"
            group_by = 'city'
        }
        if(type==='Team Name'){
            fn='open_tickets_aging_team_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_team_wise"
            group_by = 'team'
        }
        if(type==='Store Name'){
            fn='open_tickets_aging_store_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_store_wise"
            group_by = 'store'
        }
        if(type==='State'){
            fn='open_tickets_aging_state_wise.csv.gz';
            url = '/service_reports/open_tickets_aging_v2';
            report_code = "open_tickets_aging_state_wise"
            group_by = 'state'
        }
        let filters = {
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            download: 1,
            report_code:report_code,
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths,
            merchant: this.state.merchantID,
            chain: this.state.chainID,
            store: this.state.storeID ,
            issue_category: this.state.cf_issue_sub_category,
            city: this.state.city,
            state: this.state.state,
            channel: this.state.channel,
            product: this.state.product,
            team: this.state.team,
            ageing: this.state.ageing,
            aso_assignment: this.state.aso_assignment,
            tat_status: this.state.tat_status,
            group_by:group_by
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, url, fn, 180);
    }
    handleRefresh(type, e) {
        this.setState(
            {
                shouldLoadData: true,
            },
            () => {
                if (type === 'Merchant Name' && this.state.object_type==='Innoviti') {
                    this.refs.merchantTabRef.get_filtered_open_aging_merchant();
                }
                if (type === 'Issue Category') {
                    this.refs.issue_categoryTabRef.get_filtered_open_aging_issue_category();
                }
                if (type === 'Channel') {
                    this.refs.channelTabRef.get_filtered_open_aging_channel();
                }
                if (type === 'Product') {
                    this.refs.productTabRef.get_filtered_open_aging_product();
                }
                if (type === 'City') {
                    this.refs.cityTabRef.get_filtered_open_aging_city();
                }
                if (type === 'Team Name') {
                    this.refs.teamTabRef.get_filtered_open_aging_team();
                }
                if (type === 'Store Name') {
                    this.refs.storeTabRef.get_filtered_open_aging_store();
                }
                if (type === 'State') {
                    this.refs.stateTabRef.get_filtered_open_aging_state();
                }
            }
        );
    }


    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date, date_config.end_date, date_config.display_start_date, date_config.display_end_date, date_config.start_date_value, date_config.end_date_value);

        if(this.state.object_type === 'Innoviti') {
            this.refs.merchantFilter.restMerchantFilter();
//             this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
             this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false, '');
//             this.refs.reloadUtid.ci_utid('', '', '', false, '');
        }
        if(this.state.object_type === 'Merchant') {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code, false, '');
            this.refs.reloadUtid.ci_utid(this.state.object_code, '', '', false, '');
        }
        if(this.state.object_type === 'Chain') {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code, false, '');
            this.refs.reloadUtid.ci_utid('', this.state.object_code, '', false, '');
        }
        if(this.state.object_type === 'Store') {
            this.refs.reloadUtid.ci_utid('', '', this.state.object_code, false, '');
        }

        this.refs.OpenTicketIssueSubCategoryFilter.restOpenTicketIssueSubCategoryFilter();
        this.refs.ChannelNameFilter.resetChannelFilter();
        this.refs.productTypeFilter.resetProductFilter();
        this.refs.cityFilter.resetCityFilter();
        this.refs.stateFilter.resetStateFilter();
        this.refs.TeamNameFilter.resetTeamFilter();
        this.refs.ageingFilter.resetAgeingFilter();
        this.refs.asoAssignmentFilter.resetAsoAssignmentFilter();
        this.refs.tatStatusFilter.resetTatStatusFilter();

        this.setState({
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            merchantID: '',
            chainID: '',
            storeID: '',
            storeValue: [],
            merchantValue: [],
            chainValue: [],
            ciutidIds: '',
            isChange: false,
            issue_type: "",
            cf_issue_sub_category: "",
            cf_merchant_contact_number: "",
            channel:"",
            city:"",
            state:"",
            team:"",
            product:"",
            ageing: AGE_BUCKETS.slice(),
            aso_assignment: ASO_ASSIGNMENT_BUCKETS.slice(),
            tat_status: TAT_STATUS_DEFAULT.slice(),
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }

    handleMerchant = (optionSelected, merchantID) => {
        this.setState({
            merchantID: merchantID,
            isChange: true,
            chainID: '',
            storeID: '',
            ciutidIds: '',
        });
//         this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
//         this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code, false, '');
//         this.refs.reloadUtid.ci_utid(merchantID, '', '', false, '');
    }

    handleChain = (optionSelected, chainID) => {
        this.setState({
            chainID: chainID,
            isChange: true,
            storeID: '',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID, false, '');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID, '', false, '');
    }

    handleStore = (storeID) => {
        this.setState({
            storeID: storeID,
            isChange: true,
            ciutidIds: '',
        });
        //this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID, storeID, false, '');
    }

    handleOpenTicketIssueSubCategory = (optionSelected, cf_issue_sub_category) => {
        this.setState({
            cf_issue_sub_category: cf_issue_sub_category,
            isChange: true
        });
    }
    handleCity = (optionSelected, city) => {
        this.setState({
            city: city,
            isChange: true
        });
    }
    handleChannel = (optionSelected, channel) => {
        this.setState({
            channel: channel,
            isChange: true
        });
    }
    handleProduct = (optionSelected, product) => {
        this.setState({
            product: product,
            isChange: true
        });
    }
    handleTeam = (optionSelected, team) => {
        this.setState({
            team: team,
            isChange: true
        });
    }
    handleAgeing = (optionSelected, ageing) => {
        this.setState({
            ageing: ageing,
            isChange: true
        });
    }
    handleAsoAssignment = (optionSelected, aso_assignment) => {
        this.setState({
            aso_assignment: aso_assignment,
            isChange: true
        });
    }
    handleTatStatus = (optionSelected, tat_status) => {
        this.setState({
            tat_status: tat_status,
            isChange: true
        });
    }
    handleState = (_optionSelected, state) => {
        this.setState({
            state: state,
            isChange: true
        });
    }
    handleDownload = (reportType) => {
        //this.TicketDownloadCheck(reportType);
    }

    get_selected_tab(object_type, object_code, selected_tab, event){
        this.setState({
            selected_tab: selected_tab,
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        });
    }
    handleApplyFilters = () => {
        this.setState({
            isChange: false,
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        });
    }
    toggleFilterPanel = () => {
        this.setState(prevState => ({
            isFilterVisible: !prevState.isFilterVisible
        }));
    }
    render() {
        console.log('Parent render - shouldLoadData:', this.state.shouldLoadData)
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title service-title">Open Tickets Ageing Report</h4>
                                        <p className="category"></p>
                                        <LastRefresh />
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        <div className="report-header-icons">
                                            <div className="icon-button filter-icon" title="Filter Report"
                                              onClick={this.toggleFilterPanel}>
                                                <i className="fa fa-filter"></i>
                                            </div>
                                            <div className="icon-button refresh-icon" title="Refresh Report"
                                              onClick={this.handleRefresh.bind(this, this.state.selected_tab)}>
                                                <i className="fa fa-refresh"></i>
                                            </div>
{/*                                             <div className="icon-button print-icon"  title="Print Report" onClick={this.handlePrint}> */}
{/*                                                 <i className="fa fa-print"></i> */}
{/*                                             </div> */}
{/*                                             <div className="icon-button email-icon"  title="Email Report"> */}
{/*                                                 <i className="fa fa-envelope"></i> */}
{/*                                             </div> */}
                                            <div className="icon-button download-icon"  title="Download Report" onClick={this.TicketDownloadCheck.bind(this, this.state.selected_tab)}>
                                                <i className="fa fa-download"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className = "clearfix"></div>

                                <div className="content-service">
                                    <div className="">
                                        <div className={`col-md-12 filter-panel ${this.state.isFilterVisible ? 'show' : 'hide'}`}>
                                            <div className="filter-grid">
                                                <div className="filter-item date-icon-small">
                                                    <label>Ticket Logged In Date</label>
                                                    <DateRangeFilter ref="daterangeFilter" onSelectDate={this.handleDateRange} start_date={this.state.datefrom} end_date={this.state.dateTo} display_start_date={this.state.datefromShow} display_end_date={this.state.dateToShow} start_date_limit={this.state.dateFromLimit} />
                                                </div>
                                                {this.state.object_type === 'Innoviti' ?
                                                    <div className="filter-item">
                                                        <label>Merchants</label>
                                                        <MerchantFilter ref="merchantFilter" onSelectMerchant={this.handleMerchant} object_type={this.state.object_type} object_code={this.state.object_code} user_type={this.state.userType}/>
                                                    </div> : null}
                                                {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' || this.state.object_type === 'Chain' || this.state.object_type === 'Store' ?
                                                    <div className="filter-item">
                                                        <label>Store</label>
                                                        <StoreFilter ref="reloadStore" onSelectStore={this.handleStore} object_type={this.state.object_type} object_code={this.state.object_code} user_type={this.state.userType}/>
                                                    </div> : null}
                                                {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' ?
                                                    <div className="filter-item">
                                                        <label>Issue Category</label>
                                                        <OpenTicketIssueSubCategory ref="OpenTicketIssueSubCategoryFilter" onSelectOpenTicketIssueSubCategory={this.handleOpenTicketIssueSubCategory} />
                                                    </div> : null}
                                                <div className="filter-item">
                                                    <label>State</label>
                                                    <StateFilter ref="stateFilter" onSelectstate={this.handleState}/>
                                                </div>
                                                <div className="filter-item">
                                                    <label>City</label>
                                                    <CityFilter ref="cityFilter" onSelectCity={this.handleCity}/>
                                                </div>
                                                <div className="filter-item">
                                                    <label>Team Name</label>
                                                    <TeamNameFilter ref="TeamNameFilter" onSelectTeam={this.handleTeam} report_type='open-tickets-aging-report' />
                                                </div>
                                                <div className="filter-item">
                                                    <label>Channel</label>
                                                    <ChannelNameFilter ref="ChannelNameFilter" onSelectChannel={this.handleChannel} />
                                                </div>
                                                {this.state.object_type === 'Innoviti' ?
                                                    <div className="filter-item">
                                                        <label>Product Type</label>
                                                        <ProductTypeFilter ref="productTypeFilter" onSelectProduct={this.handleProduct} userType={this.state.userType}/>
                                                    </div> : null}
                                                <div className="filter-item">
                                                    <label>Ageing (Days)</label>
                                                    <OpenTicketAgeingFilter ref="ageingFilter" onSelectAgeing={this.handleAgeing} />
                                                </div>
                                                <div className="filter-item">
                                                    <label>ASO Assignment</label>
                                                    <AsoAssignmentFilter ref="asoAssignmentFilter" onSelectAsoAssignment={this.handleAsoAssignment} />
                                                </div>
                                                <div className="filter-item">
                                                    <label>TAT Status</label>
                                                    <TatStatusFilter ref="tatStatusFilter" onSelectTatStatus={this.handleTatStatus} />
                                                </div>
                                                <div className="filter-actions">
                                                    <button type="button" className="primary apply-filter" role="button" onClick={this.handleApplyFilters}>Apply</button>
                                                    <button type="button" className="primary reset-filter" role="button" onClick={this.reset_all.bind(this)}>Reset</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">

                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep-service-pages"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                            <TabList>
                                                {this.state.object_type === 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Merchant Name','')}>Merchant Name</Tab> :
                                                null}
                                                {this.state.object_type !== 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Store Name','')}>Store Name</Tab>:
                                                null}
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Issue Category','')}>Issue Category</Tab>
                                                {this.state.object_type === 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Team Name','')}>Team Name</Tab>:
                                                null}
{/*                                                 <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Team Member Name','')}>Team Member Name</Tab> */}
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Channel','')}>Channel</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Product','')}>Product</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'City','')}>City</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'State','')}>State</Tab>
                                            </TabList>
                                            {this.state.object_type === 'Innoviti' ?
                                            <TabPanel>
                                                <MerchantTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="merchantTabRef"
                                                    //onDownload={this.handleDownload}
                                                />
                                            </TabPanel> : null}
                                            {this.state.object_type !== 'Innoviti' ?
                                            <TabPanel>
                                                <StoreTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="storeTabRef"
                                                    //onDownload={this.handleDownload}
                                                />
                                            </TabPanel>: null}

                                            <TabPanel>
                                                <IssueCategoryTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="issue_categoryTabRef"
                                                    //onDownload={this.handleDownload}
                                                />

                                            </TabPanel>
                                            {this.state.object_type === 'Innoviti' ?
                                             <TabPanel>
                                                 <TeamTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="teamTabRef"
                                                    //onDownload={this.handleDownload}
                                                />
                                            </TabPanel>: null}

                                            <TabPanel>
                                                <ChannelTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="channelTabRef"
                                                    //onDownload={this.handleDownload}
                                                />

                                            </TabPanel>

                                            <TabPanel>
                                                <ProductTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="productTabRef"
                                                    //onDownload={this.handleDownload}
                                                />

                                            </TabPanel>

                                            <TabPanel>
                                                <CityTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    storeID={this.state.storeID}
                                                    chainID={this.state.chainID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="cityTabRef"
                                                    //onDownload={this.handleDownload}
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                <StateTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    storeID={this.state.storeID}
                                                    chainID={this.state.chainID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    state={this.state.state}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    ageing={this.state.ageing}
                                                    aso_assignment={this.state.aso_assignment}
                                                    tat_status={this.state.tat_status}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="stateTabRef"
                                                    //onDownload={this.handleDownload}
                                                />
                                            </TabPanel>

{/*                                             <TabPanel> */}
{/*                                             </TabPanel> */}
                                        </Tabs>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => {dispatch({type:'change_menu',payload:name})}
    }
}

export default connect(null, mapDispatchToProps)(OpenTicketsAgingReport);